<template>
  <v-container>
    <youtube :video-id="id" :player-width="playerWidth" :player-height="playerHeight"></youtube>
  </v-container>
</template>

<script>
export default {
  name: "YoutubeContainer",
  props: {
    id: String
  },
  computed: {
    /* eslint-disable */
    playerHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "300px";
        case "sm":
          return "360px";
        case "md":
          return "360px";
        case "lg":
          return "360px";
        case "xl":
          return "360px";
      }
    },
    playerWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "300px";
        case "sm":
          return "640px";
        case "md":
          return "640px";
        case "lg":
          return "640px";
        case "xl":
          return "640px";
      }
    }
  }
};
</script>